export default __webpack_public_path__ + "static/media/Tek.dfc02f1d.svg";